import { useMutation } from '@apollo/client';
import { AntModal, Loading } from '../../components';
import StandaloneForm from '../generic/Form/StandaloneForm';
import { CREATE_BUSINESS_FUNCTION } from '../../pages/dataInputs/data-inputs/business-functions/queries';
import { useState } from 'react';
import { RefetchQueries } from '../../interfaces/GraphQLTypes';

type BusinessFunctionAddModalProps = {
  isOpen: boolean;
  onClose: () => void;
  refetchQueries?: RefetchQueries;
};

export const BusinessFunctionAddModal = ({
  isOpen,
  onClose,
  refetchQueries,
}: BusinessFunctionAddModalProps) => {
  const [createFunctionLoading, setCreateFunctionLoading] = useState(false);

  const [createBusinessFunction] = useMutation(CREATE_BUSINESS_FUNCTION, {
    refetchQueries,
  });

  const formFields = [
    {
      key: 'name',
      label: 'Business Function',
      isRequired: true,
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textArea',
      isRequired: false,
    },
  ];

  return (
    <AntModal
      title="Add Business Function"
      openModal={isOpen}
      onCancel={onClose}
    >
      {createFunctionLoading ? (
        <Loading />
      ) : (
        <StandaloneForm
          fields={formFields}
          createGQL={createBusinessFunction}
          onFinalize={onClose}
          setIsLoading={setCreateFunctionLoading}
        />
      )}
    </AntModal>
  );
};
